import { render, staticRenderFns } from "./BookAppointment.vue?vue&type=template&id=1a3d3576&"
import script from "./BookAppointment.vue?vue&type=script&lang=ts&"
export * from "./BookAppointment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports